import { Flex } from '@chakra-ui/react';
import AuthenticatedPageWrapper from 'app/components/UI/AuthenticatedPageWrapper';
import CenterSpinner from 'app/components/UI/CenterSpinner';
import { useManagingCompanyStore } from 'app/store';
import useFetchCompany from 'app/hooks/useFetchCompany';
import useFetchCompanyConfiguration from 'app/hooks/useFetchCompanyConfiguration';
import usePots, { companyPotQueryParams } from 'app/hooks/usePots';

import CompanyWallet from './CompanyWallet/CompanyWallet';
import Pots from './Pots/Pots';

function WalletsAndPots() {
  const company = useManagingCompanyStore((state) => state.company);

  const companyId = company?.id || '';

  const { data: companyData, isLoading: isLoadingCompany } = useFetchCompany(companyId);
  const { data: companyPots, isLoading: isLoadingCompanyPot } = usePots.useFetchPots(
    companyPotQueryParams(companyId)
  );
  const { data: companyConfig } = useFetchCompanyConfiguration(companyId);

  const rewardAndRecognitionStatus = companyConfig?.modulesConfig?.modules?.REWARD_AND_RECOGNITION;
  const isRewardAndRecognitionProvisioned =
    rewardAndRecognitionStatus === 'DISABLED' || rewardAndRecognitionStatus === 'ENABLED';

  const companyPot = companyPots?.list?.[0];

  if (isLoadingCompany || isLoadingCompanyPot) {
    return <CenterSpinner />;
  }

  return (
    <AuthenticatedPageWrapper
      title={isRewardAndRecognitionProvisioned ? 'Wallets & Pots' : 'Wallets'}
    >
      <Flex direction="column" gap="30px">
        <CompanyWallet company={companyData} companyPot={companyPot} />
        {isRewardAndRecognitionProvisioned && (
          <Pots company={companyData} companyPot={companyPot} companyId={companyId} />
        )}
      </Flex>
    </AuthenticatedPageWrapper>
  );
}

export default WalletsAndPots;
